module.exports = __webpack_public_path__ + "img/relais-&-chateaux-press-office.dc87152a.png";